import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const keyPrefix = 'user_form';
export const useUserFormTranslation = (): UseTranslationResponse<'entities', typeof keyPrefix> => useTranslation('entities', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    title_create: 'Новый пользователь',
    title_update: 'Изменить данные пользователя',
    title_duplicate: 'Дублировать пользователя',
    subtitle: 'Будет создан новый пользователь и все параметры его доступа будут такими же как у {{name}}',
    name_label: 'Имя',
    email_label: 'Email',
    password_label: 'Пароль',
    role_label: 'Роль',
    role_placeholder: 'Выберите',
    submit_create: 'Создать',
    submit_update: 'Сохранить',
    submit_duplicate: 'Создать',
    cancel: 'Отмена',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title_create: 'New user',
    title_update: 'Edit user data',
    title_duplicate: 'Duplicate user',
    subtitle: 'A new user will be created and all their access parameters will be the same as {{name}}',
    name_label: 'Name',
    email_label: 'Email',
    password_label: 'Password',
    role_label: 'Role',
    role_placeholder: 'Select',
    submit_create: 'Create',
    submit_update: 'Save',
    submit_duplicate: 'Create',
    cancel: 'Cancel',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title_create: 'Nuevo usuario',
    title_update: 'Editar datos del usuario',
    title_duplicate: 'Duplicar usuario',
    subtitle: 'Se creará un nuevo usuario y todos sus parámetros de acceso serán los mismos que los de {{name}}',
    name_label: 'Nombre',
    email_label: 'Email',
    password_label: 'Contraseña',
    role_label: 'Rol',
    role_placeholder: 'Seleccione',
    submit_create: 'Crear',
    submit_update: 'Guardar',
    submit_duplicate: 'Crear',
    cancel: 'Cancelar',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title_create: 'Novo usuário',
    title_update: 'Editar dados do usuário',
    title_duplicate: 'Duplicar usuário',
    subtitle: 'Um novo usuário será criado e todos os seus parâmetros de acesso serão os mesmos de {{name}}',
    name_label: 'Nome',
    email_label: 'Email',
    password_label: 'Senha',
    role_label: 'Função',
    role_placeholder: 'Selecione',
    submit_create: 'Criar',
    submit_update: 'Salvar',
    submit_duplicate: 'Criar',
    cancel: 'Cancelar',
  },
}) as Record<string, unknown>;
